<template>
    <div style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <van-nav-bar title="援助申请" left-arrow @click-left="onClickLeft" />
        <div style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll">
            <van-divider>基本信息</van-divider>
            <van-form ref="basicInfoForm" >
                <van-field label="申请人" readonly :value = "assistance.applyName"/>
                <van-field label="身份证号" readonly :value="assistance.applyIDNum" />

                <van-field label="电话" readonly :value="assistance.phone"/>
                <van-field label="性别" readonly :value="assistance.sex===1?'男':'女'"/>

                <van-field label="出生日期"  readonly  :value="assistance.birthday" />

                <van-field label="职业"  readonly v-model="assistance.professional" />
                <van-field label="民族"  readonly :value="assistance.national"/>

                <van-field label="住址所在地" readonly :value="assistance.address" type="textarea" autosize/>
                <van-field label="案情" readonly :value="assistance.theCase" type="textarea" autosize/>
            </van-form>
            <div style="margin: 10px 16px;">
                <van-divider>身份证</van-divider>
                <div  style="display: flex;flex-direction: row;">
                    <div style="flex: 1;margin: 5px 10px;display:flex;flex-direction: column;align-items: center;justify-content: center">
                        <img v-if="assistance.idCardImgA" width="90%" :src="assistance.idCardImgA" @click="showImage(assistance.idCardImgA)" >
                        <div style="font-size: 14px;color: #969799" v-else>暂无身份证图片</div>
                    </div>
                    <div style="flex: 1;margin: 5px 10px;display:flex;flex-direction: column;align-items: center;justify-content: center">
                        <img v-if="assistance.idCardImgB" width="90%" :src="assistance.idCardImgB" @click="showImage(assistance.idCardImgB)" >
                        <div style="font-size: 14px;color: #969799" v-else>无身份证图片</div>
                    </div>
                </div>

                <van-divider>其他资料</van-divider>
                <div style="display: flex;flex-direction: row;flex-wrap: wrap;">
                    <div style="flex: 1;margin: 5px 10px;">
                        <img  v-if="assistance.img1"  width="100%" :src="assistance.img1"  @click="showImage(assistance.img1)" >
                    </div>
                    <div style="flex: 1;margin: 5px 10px;">
                        <img  v-if="assistance.img2"   width="100%" :src="assistance.img2"  @click="showImage(assistance.img2)" >
                    </div>
                    <div style="flex: 1;margin: 5px 10px;">
                        <img style="flex: 1;margin: 5px 10px;"    width="100%" v-if="assistance.img3"  :src="assistance.img3"  @click="showImage(assistance.img3)" >
                    </div>
                    <div style="flex: 1;margin: 5px 10px;">
                        <img style="flex: 1;margin: 5px 10px;"   width="100%"  v-if="assistance.img4"  :src="assistance.img4"  @click="showImage(assistance.img4)" >
                    </div>
                    <div style="flex: 1;margin: 5px 10px;">
                        <img style="flex: 1;margin: 5px 10px;"  width="100%"   v-if="assistance.img5"  :src="assistance.img5"  @click="showImage(assistance.img5)" >
                    </div>
                </div>
                <div v-for="reply in replies" :key="`reply:`+reply.id">
                    <van-divider style="margin: 5px 0">{{replyTypes[reply.msgType]}}</van-divider>
                    <van-row style="margin :10px 0;">
                        <van-col span="8" style="color:#777;font-size: 14px">回复人</van-col>
                        <van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
                            <img v-if="reply.userInfo" :src="reply.userInfo.headImgUrl" width="20" style="border-radius: 10px;">
                            {{reply.userInfo?reply.userInfo.name:''}}
                        </van-col>
                    </van-row>

                    <van-row style="margin :10px 0;">
                        <van-col span="8" style="color:#777;font-size: 14px">回复时间</van-col>
                        <van-col span="16" style="font-size: 14px">{{reply.createDate}}</van-col>
                    </van-row>
                    <div style="font-size: 16px; word-break:break-all;margin: 16px 0;">{{reply.content}}</div>
                </div>
                <div v-if="userType === userTypes.lawyer">

                    <div v-if="assistance.applySite === assistanceStatus.auditing">
                        <van-divider>回复</van-divider>
                        <van-field
                                v-model="replyMessage"
                                type="textarea"
                                placeholder="请输入回复内容"
                                rows="5"
                                maxlength="300"
                                autosize
                                style="border: 1px solid #ebedf0;border-radius: 5px;margin:5px"
                                show-word-limit
                        ></van-field>
                        <van-field name="switch" label="需要修改资料">
                            <template #input>
                                <van-switch v-model="isNeedEdit" size="20" v-on:change="needEdit"/>
                            </template>
                        </van-field>
                        <div style="margin: 8px 16px;">
                            <van-button  round block slot="button" type="info" @click="reply">申请回复</van-button>
                        </div>

                        <van-divider>审批</van-divider>
                        <van-field
                                v-model="applyMessage"
                                type="textarea"
                                placeholder="请输入审批意见"
                                rows="5"
                                maxlength="300"
                                autosize
                                style="border: 1px solid #ebedf0;border-radius: 5px;margin:5px"
                                show-word-limit
                        ></van-field>
                        <div style="margin: 8px 16px;">
                            <van-button  round block  slot="button" @click="apply(2)" type="primary">同意援助</van-button>
                        </div>

                        <div style="margin: 8px 16px;">
                            <van-button  round block  slot="button" @click="apply(3)" type="danger">驳回援助</van-button>
                        </div>
                    </div>
                    <van-divider v-else-if="assistance.applySite === assistanceStatus.reject">该申请已被拒绝</van-divider>
                    <van-divider v-else-if="assistance.applySite === assistanceStatus.agree">该申请已被同意</van-divider>

                </div>
                <div v-if="userType === userTypes.customer">
                    <div v-if="assistance.applySite === assistanceStatus.auditing">
                        <div v-if="this.replies.length>0&&this.replies[this.replies.length-1].msgType=== 0">
                            <van-divider>追问</van-divider>
                            <van-field
                                    v-model="askMessage"
                                    type="textarea"
                                    placeholder="请输入追问内容"
                                    rows="5"
                                    maxlength="300"
                                    autosize
                                    style="border: 1px solid #ebedf0;border-radius: 5px;margin:5px"
                                    show-word-limit
                            ></van-field>
                            <div style="margin: 8px 16px;">
                                <van-button  round block slot="button" type="primary" @click="ask">追问</van-button>
                            </div>
                        </div>
                        <van-divider v-else>
                            正在等待律师回复
                        </van-divider>
                        <div style="margin: 8px 16px;" v-if="assistance.ifEdit">
                            <van-button
                                    round block
                                    type="primary"
                                    @click="gotoEdit"
                            >修改资料</van-button>
                        </div>

                    </div>
                    <van-divider v-else-if ="assistance.applySite === assistanceStatus.agree">
                        您的援助申请已通过审核
                    </van-divider>
                    <van-divider v-else-if ="assistance.applySite === assistanceStatus.reject">
                        您的援助申请被退回
                    </van-divider>
                    <div v-else-if ="assistance.applySite=== assistanceStatus.waitSubmit">
                        <div style="margin: 8px 16px;" v-if="assistance.ifEdit">
                            <van-button
                                    round block
                                    type="primary"
                                    @click="gotoEdit"
                            >修改资料</van-button>
                        </div>
                        <div style="margin: 8px 16px;">
                            <van-button
                                    round block
                                    type="primary"
                                    @click="submit2Audit"
                            >提交审核</van-button>
                        </div>
                    </div>

                </div>
            </div>
            <van-overlay
                    :show="showImageOverlay"
                    @click="showImageOverlay = false"
                    style = "display: flex;justify-content: center;align-items: center"
            >
                <img :src="overlayImageUrl" width="90%">
            </van-overlay>
        </div>
    </div>
</template>

<script>
  import {assistanceStatus,responseCodes,userTypes} from '../../common/const'
  import axios from '../../common/axios'
  import {Toast} from 'vant'
  export default {
    name: "Assistance",
    data() {
      return {
        message:'',
        assistance:{},
        userType:userTypes.customer,
        assistanceStatus,
        userTypes,
        askMessage:'',
        replyMessage:'',
        applyMessage:'',
        isNeedEdit:false,
        replies:[],
        replyTypes:{
          0:'回复',
          1:'追问'
        },
        overlayImageUrl:'',
        showImageOverlay:false

      };
    },

    mounted(){



	   if (this.$route.params.item){
	         this.assistance = this.$route.params.item
	         localStorage.setItem("currentAssistance",JSON.stringify(this.assistance))
	         this.userType = this.$route.params.userType  ;
	         localStorage.setItem("currentUserType",this.userType)
       }else if (localStorage.getItem("currentAssistance")){
         this.assistance=JSON.parse(localStorage.getItem("currentAssistance"))
         this.userType = +localStorage.getItem("currentUserType")
         this.$forceUpdate()
      }
      this.isNeedEdit = this.assistance.ifEdit
      this.getReplies();
    },
    methods:{
      showImage(imgUrl){
        this.overlayImageUrl =imgUrl;
        this.showImageOverlay =true;
      },
      onClickLeft() {
        this.$router.back();
      },
      async getReplies(){
        try {
          let response = await axios.post(`/fyserve/apply/msg/find?applyId=${this.assistance.id}`)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.replies = data.data

          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }
      },
      gotoEdit(){
      this.$router.push({
        name:'edit-assistance',
        params:{
          assistance:this.assistance,
        }
      })
      },
      async needEdit(){
        try {
          let body = {
            ifEdit:this.isNeedEdit
          }
          let response = await axios.post(`/fyserve/apply/edit?applyId=${this.assistance.id}` ,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            Toast.success("援助状态已更新")
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
        }
      },
      async submit2Audit(){
        if (this.assistance.appImgUrl &&
          this.assistance.proofImgUrl &&
          this.assistance.idCardImgA &&
          this.assistance.idCardImgB
        ) {
          try {
            let response = await axios.post(`/fyserve/apply/sub?applyId=${this.assistance.id}`)
            let data = response.data;
            if (data.code === responseCodes.success) {
              this.$router.go(-1);
            }else{
              Toast.fail(data.message);
            }
          }catch (e) {
            console.error(e)
          }
        }else {
          Toast.fail("请上传全部照片后在提交审核")
        }
      },

      async ask(){
        if(this.askMessage.trim() ===''){
          Toast.fail("请输入追问内容");
          return ;
        }
        this.$store.commit("showOverlay")
        try {
          let body = {
            openId:this.$store.state.user.openId,
            content:this.askMessage,
            msgType:1,
            applyId:this.assistance.id
          }
          let response = await axios.post("/fyserve/apply/msg/add" ,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.askMessage = ''
            this.getReplies();

            this.updateAssistance();
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
        }

        this.$store.commit("hideOverlay")
      },
      async apply(applyType){
        if (this.applyMessage.trim() ===''){
          Toast.fail("请输入审批意见内容");
          return ;
        }

        this.$store.commit("showOverlay")
        try {
          let body = {
            openId:this.$store.state.user.openId,
            content:this.applyMessage,
            msgType:applyType,
            applyId:this.assistance.id
          }
          let response = await axios.post("/fyserve/apply/msg/add" ,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.applyMessage = ''
            this.getReplies();
            this.updateAssistance();
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
        }

        this.$store.commit("hideOverlay")

      },
      async reply(){
        if (this.replyMessage.trim() ===''){
          Toast.fail("请输入回复内容");
          return ;
        }
        this.$store.commit("showOverlay")
        try {
          let body = {
            openId:this.$store.state.user.openId,
            content:this.replyMessage,
            msgType:0,
            applyId:this.assistance.id
          }
          let response = await axios.post("/fyserve/apply/msg/add" ,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.replyMessage = ''
            this.getReplies();
            console.info('---------------------')
            this.updateAssistance();
            console.info('---------------------')

          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
        }
        this.$store.commit("hideOverlay")
      },

      async updateAssistance() {
        let body = {id:this.assistance.id};
        try {
          let response = await axios.post(`/fyserve/apply/find?page=1&size=1`,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.assistance = data.data[0]
            localStorage.setItem("currentAssistance",JSON.stringify(this.assistance))
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }
      },
    },

  }
</script>

<style scoped>

</style>